import { Component } from 'react';
import { connect } from 'react-redux';
import MultiSelect from '../../common/form/multi-select';
import RequiredMultiSelect from '../../common/form/elements/required-multi-select';

class GroupMultiSelect extends Component {
  render() {
    const {
      required, groups, value, ...rest
    } = this.props;

    const Select = required ? RequiredMultiSelect : MultiSelect;

    const data = groups.map(group => ({
      label: group.attributes.name,
      value: group.id
    }));

    return (
      <Select
        data={data}
        value={value}
        label="Eligible groups"
        messages={{
          required: 'You must select at least one group'
        }}
        {...rest}
      />
    );
  }
}

const mapStateToProps = state => ({
  groups: state.groups.groups
});

export default connect(mapStateToProps)(GroupMultiSelect);
